/* Copyright (C) 2019 SmartboxTv S.A. - All rights reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Erasmo Marín <emarin@smartboxtv.com>
 */

import React from 'react';
import { Dialog } from './components/dialogs';
import { inject } from 'mobx-react';
import _ from './translations';

/**
 * A component that shows a dialog if a new version is found after a deployment
 */
@inject('appStore')
class VersionCheck extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            version: false,
            versionChanged: false,
        };
    }

    async componentDidMount() {
        const { appStore } = this.props;
        const _this = this;

        await appStore.getConsoleVersion();

        if (appStore.version !== false) {
            this.setState({ version: appStore.version }, () => {
                setInterval(async function() {
                    await appStore.getConsoleVersion();
                    if (appStore.version !== _this.state.version && appStore.version !== false) {
                        _this.setState({ version: appStore.version, versionChanged: true });
                    }
                }, 30000);
            });
        }
    }

    reload = () => {
        window.location.reload();
    };

    render() {
        const { appStore } = this.props;

        return (
            <If condition={this.state.versionChanged}>
                <Dialog
                    type="confirm"
                    onAccept={this.reload}
                    onCancel={() => this.setState({ versionChanged: false })}
                    message={_('A new version is available, please reload to get last version')}
                    open={this.state.versionChanged}
                >
                    <If condition={appStore.releaseNotes}>
                        <p>{_('Release Notes:')}</p>
                        <div
                            dangerouslySetInnerHTML={{
                                __html: _(appStore.releaseNotes),
                            }}
                        />
                    </If>
                </Dialog>
            </If>
        );
    }
}

export default VersionCheck;
